<template>
  <div>
    <h1>Table Test</h1>
    <VueGoodTable v-bind="table">
      <template #table-column="{ column }">
        <VTableHeader :columns="table.columns" :column="column" />
        {{ column.sortable ? ' Sortable' : ' Not Sortable' }}
      </template>
    </VueGoodTable>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import VTableHeader from '@/components/Table/Header';
import TableMixin from '@/mixins/table';

export default {
  name: 'TableTest',
  components: {
    VueGoodTable,
    VTableHeader,
  },
  mixins: [TableMixin],
  data() {
    return {
      table: {
        columns: [
          { label: 'Name', field: 'Name', sortable: true },
          { label: 'Age', field: 'Age', sortable: true },
          { label: 'City', field: 'City', sortable: false },
        ],
        rows: [
          { Name: 'Alice', Age: '25', City: 'New York' },
          { Name: 'Bob', Age: '30', City: 'Los Angeles' },
          { Name: 'Charlie', Age: '35', City: 'Chicago' },
        ],
        defaultSortBy: { field: 'Name', type: 'desc' },
      },
    };
  },
};
</script>
